import apiClient from './apiClient';

// ΛΑ-02 / **D45**: η αλλαγή ηλεκτρονικής διεύθυνσης, ως δικό της άρθρωμα.
//
// **Γιατί χωριστό αρχείο και όχι μέθοδοι στο `auth.service.js`:** ο κανόνας
// παράλληλης εργασίας ορίζει ότι ο μεταφορέας ανήκει στον κλάδο που τον κατέχει,
// και κάθε άλλος κλάδος φτιάχνει **δικό του** άρθρωμα πάνω στον υπάρχοντα
// `apiClient`. Νέο αρχείο δεν συγκρούεται ποτέ.

/**
 * Αίτημα αλλαγής. Επιστρέφει τη **μασκαρισμένη** νέα διεύθυνση, ώστε η οθόνη να
 * δείξει την εκκρεμότητα χωρίς δεύτερη κλήση.
 */
export function requestEmailChange(newEmail, currentPassword) {
    return apiClient.post('/api/auth/email-change', { newEmail, currentPassword });
}

/**
 * Επιβεβαίωση από τον σύνδεσμο του μηνύματος.
 *
 * **Χωρίς ταυτοποίηση** (`auth: false`), και είναι απόφαση του διακομιστή που η
 * οθόνη απλώς τηρεί: ο σύνδεσμος ανοίγει στο πρόγραμμα περιήγησης όπου
 * διαβάζεται το μήνυμα, που είναι συνήθως **άλλο** από εκείνο της συνεδρίας.
 */
export function confirmEmailChange(token) {
    return apiClient.post('/api/auth/email-change/confirm', { token }, { auth: false });
}

/** Ακύρωση εκκρεμούς αιτήματος. Επαναφέρει την κατάσταση πριν από το αίτημα. */
export function cancelEmailChange() {
    return apiClient.del('/api/auth/email-change');
}

export default { requestEmailChange, confirmEmailChange, cancelEmailChange };
